import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';
import { DefaultTFuncReturn } from 'i18next';

export const showErrorNotification = (
	err: AxiosError,
	defaultErrorMessage?: string | DefaultTFuncReturn,
): void => {
	if (err?.response?.status === 429 || err?.response?.status === 412) return;
	const message = getErrorMessage(err, defaultErrorMessage);
	enqueueSnackbar({ message, variant: 'error' });
};
